import { useEffect } from 'react';

// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

export const initMetaPixel = () => {
  // Check if fbq is already loaded
  if (window.fbq) return;

  (function(f: any, b: Document, e: string, v: string, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
    null,
    null,
    null
  );

  if (window.fbq) {
    (window.fbq as any)('init', '880394748795777');
    (window.fbq as any)('track', 'PageView');
  }
};

// Helper functions for tracking events
export const trackLead = () => {
  if (window.fbq) {
    window.fbq('track', 'Lead');
    console.log('🎯 Meta Pixel: Lead event tracked');
  }
};

export const trackPurchase = (value: number = 0.00, currency: string = 'AUD') => {
  if (window.fbq) {
    window.fbq('track', 'Purchase', { value, currency });
    console.log('🎯 Meta Pixel: Purchase event tracked', { value, currency });
  }
};

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart');
    console.log('🎯 Meta Pixel: AddToCart event tracked');
  }
};

// Component to initialize Meta Pixel
function MetaPixel() {
  useEffect(() => {
    initMetaPixel();
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=880394748795777&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
}

export default MetaPixel;